import gql from 'graphql-tag';

export const getSCADAControlValues = gql`
  query getSCADAControlValues {
    getSCADAControlValues {
      id
      name
      createdAt
      createdBy
      updatedAt
      updatedBy
      deletedAt
    }
  }
`;
